export default __webpack_public_path__ + "static/media/wildfire.92de6bb2.svg";